import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { IonicModule } from "@ionic/angular";
import { HintComponent } from "./hint.component";
import { OverlayHintComponent } from "./overlay-hint.component";
import { HintsService } from "./hints.service";

/**
 * Provides hint service and component for the app
 */
@NgModule({
  declarations: [HintComponent, OverlayHintComponent],
  exports: [HintComponent, OverlayHintComponent],
  imports: [CommonModule, IonicModule],
  providers: [HintsService],
})
export class HintModule {}
